import axios from 'axios';
import { logout } from '../store/slices/authSlice';

const axiosInstance = axios.create();

let store;

export const injectStore = _store => {
	store = _store
}


// Add a request interceptor
axiosInstance.interceptors.request.use(
	(config) => {
		if (!config.headers['Authorization']) {
			config.headers['Authorization'] = `Bearer ${store.getState().authSlice.token}`;
		}

		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		if (error.response && error.response.status === 401) {
			store.dispatch(logout());
			// REACT_APP_BASE_URL is the app's router basename (see index.js), not a
			// full redirect URL - when unset this used to evaluate to the literal
			// string "undefined", sending the browser to /undefined before it fell
			// through to /login. Treat it as a path prefix instead.
			// eslint-disable-next-line no-undef
			window.location.href = `${process.env.REACT_APP_BASE_URL || ''}/login`;
			return Promise.reject(error.response);
		} else {
			return Promise.reject(error.response);
		}
	}
);

export default axiosInstance;
